"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerTarget = registerTarget;
exports.registerSource = registerSource;

function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}

function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/common/registration.js
// module id = 227
// module chunks = 0